// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import http from "./utils/http.js";
import FileViewer from "file-viewer";
import dateTime from "./utils/dateTime.js"; // 时间戳转换工具
Vue.use(FileViewer);
Vue.use(ElementUI);
import VueAMap from "vue-amap";
Vue.use(VueAMap);
// console.log(VueAMap);
VueAMap.initAMapApiLoader({
    key: "71b0a796ca656438ff768f3594afddf0", //申请的key码需要填写的地方，格式为长串字符数字
    plugin: [
        //按照你的需要，引入地图的哪些功能，不需要下面这么多
        "AMap.Autocomplete", //输入提示插件
        "AMap.PlaceSearch", //POI搜索插件
        "AMap.Scale", //右下角缩略图插件 比例尺
        "AMap.OverView", //地图鹰眼插件
        "AMap.ToolBar", //地图工具条
        "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
        "AMap.PolyEditor", //编辑 折线多，边形
        "AMap.CircleEditor", //圆形编辑器插件
        "AMap.Geolocation", //定位控件，用来获取和展示用户主机所在的经纬度位置
        "AMap.ControlBar",
    ],
    v: "1.4.4", // 默认高德 sdk 版本为 1.4.4
});
Vue.config.productionTip = false;
/**
 * 配置全局loading提示框
 * 显示loading this.showLoading()
 * 关闭loading this.hideLoading()
 */
Vue.prototype.loading = null;
Vue.prototype.showLoading = function(msg = "Loading") {
    Vue.prototype.loading = this.$loading({
        lock: true,
        text: msg,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
    });
};
Vue.prototype.hideLoading = function() {
    Vue.prototype.loading.close();
};
Vue.prototype.$http = http;
Vue.prototype.$dateTime = dateTime;
/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    render: (h) => h(App),
    components: { App },
    template: "<App/>",
});


// WEBPACK FOOTER //
// ./src/main.js